export default __webpack_public_path__ + "static/media/BOPPanhandleFirstBankHealthPlanBrandingLogo.ac92463c.png";